const BetaTag = () => (
  <span className="bg-sy-op-planting-teal-light rounded">
    <span className="mx-1 text-sy-op-planting-teal-dark font-semibold uppercase">Beta</span>
  </span>
);

export default BetaTag;
